import { useEffect, useRef, useState } from "react";

export const useIntersectionObserver = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    if (!("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observerInstance.disconnect(); // stop observing after loading
          }
        });
      },
      { threshold: 0 },
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  return { ref, isVisible };
};
